import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    data: [],
    usuarios: []
}

const POST_USUARIO_OC = 'POST_USUARIO_OC'
const GET_USUARIO_OC = 'GET_USUARIO_OC'
const PUT_USUARIO_OC = 'PUT_USUARIO_OC'
const GET_USUARIO_OC_EXPORTACION = 'GET_USUARIO_OC_EXPORTACION'

export const obtenerUsuariosOCNacional = createAsyncThunk(
    GET_USUARIO_OC,
    async (rol) => {
        try {
            const fullUrl = host + `Auth/obtenerUsersOC/${rol}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerUsuariosOCExportacion = createAsyncThunk(
    GET_USUARIO_OC_EXPORTACION,
    async (rol) => {
        try {
            const fullUrl = host + `Auth/obtenerUsersOCExportacion/${rol}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarUsuarioOC = createAsyncThunk(
    POST_USUARIO_OC,
    async (data) => {
        try {
            const urlAgregarLogin = host + `Auth/registrarOC`

            const dataLogin = {
                usuario: data.usuario,
                password: data.password,
                idtipousuario: Number(data.idtipousuario),
                iddatoslogin: null,
                fechainscripcion : data.fechainscripcion
            }

            if (data.puesto === 'Auxiliar Nacional') {
                dataLogin.idrol = 7
            }
            if (data.puesto === 'Auxiliar Exportación') {
                dataLogin.idrol = 8
            }
            const resLogin = await axios.post(urlAgregarLogin, {data:dataLogin} )

            return resLogin.data.data

        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarUsuarioOC = createAsyncThunk(
    PUT_USUARIO_OC,
    async (data) => {
        try {
            const urlActualizarLogin = host + `Auth/actualizarOC`
            
            if (data.puesto === 'Auxiliar Nacional') {
                data.idrol = 7
            }
            if (data.puesto === 'Auxiliar Exportación') {
                data.idrol = 8
            }
            delete data.puesto
            const resLogin = await axios.put(urlActualizarLogin, { data: data })

            return resLogin.data.data
        } catch (error) {
            console.log(error);
        }
    }
)
export const metodosGenerarUsuariosSlice = createSlice({

    name: 'metodosGenerarUsuariosSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerUsuariosOCNacional.fulfilled]: (state, { payload }) => {
            state.usuarios = payload
        },
        [obtenerUsuariosOCExportacion.fulfilled]: (state, { payload }) => {
            state.usuarios = payload
        },
    },

})


export const { } = metodosGenerarUsuariosSlice.actions
export const GenerarUsuariosReducer = metodosGenerarUsuariosSlice.reducer